import { useCallback, useEffect } from 'react';
import './youtube-player.scss';
import { loadExternalScript, uuid } from '../../services/helpers';


declare global {
    interface Window {
        onYouTubeIframeAPIReady: () => void;
        enqueueOnYoutubeIframeAPIReady: (callback: () => void) => void;
    }
}

if (!window.onYouTubeIframeAPIReady && !window.enqueueOnYoutubeIframeAPIReady) {
    const callbacks: { (): void; }[] = [];
    window.onYouTubeIframeAPIReady = () => {
        callbacks.forEach(cb => cb());
    }
    window.enqueueOnYoutubeIframeAPIReady = (callback: () => void) => {
        if (window.YT) {
            callback();
        } else {
            callbacks.push(callback);
        }
    }
}

interface IProps {
    videoId: string;
    maxHeightInPixels?: number;
    onSetPlayerInstance?: (playerId: string, player: YT.Player) => void;
}

const YouTubePlayer: React.FC<IProps> = ({ videoId, maxHeightInPixels, onSetPlayerInstance }) => {
    const playerId = uuid();
    const width = maxHeightInPixels ? maxHeightInPixels * 16 / 9 : 640;
    const height = maxHeightInPixels ? maxHeightInPixels : 360;

    const createVideoPlayerInstance = useCallback(() => {
        const player = new window.YT.Player(playerId, {
            videoId: videoId,
            width,
            height,
        });
        onSetPlayerInstance?.(playerId, player);
    }, [playerId, videoId, onSetPlayerInstance, width, height]);

    useEffect(() => {
        if (!window.YT) {
            window.enqueueOnYoutubeIframeAPIReady(createVideoPlayerInstance);
            loadExternalScript('https://www.youtube.com/iframe_api');
        } else {
            createVideoPlayerInstance();
        }
    }, [createVideoPlayerInstance]);

    return (
        <div className='youtube-player-container'>
            <div id="player-container">
                <div id={playerId} data-id={videoId}></div>
            </div>
        </div>
    );
}

export default YouTubePlayer;
